module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-v4compatibility.woff2";